import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { Controller } from '@commoncore/controller/Controller';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { RecentFilesImplementation } from '@mainrepo/app/core/implementation/RecentFilesImplementation';

export class RecentFilesController extends Controller{
    public recentFilesImplementation: any;
    public fileOperationsImplementation:any;
    public universalService: any;
    public router: any;
    public http: any;
    public fetchFolderData: boolean = false;
    public static singleInstance: any = null
    public globalService: any;
    public listService:any;
    loggerService: any;

    public constructor(globalService) {
        super(globalService);
        this.recentFilesImplementation = RecentFilesImplementation.getInstance();
        this.fileOperationsImplementation= FileOperationsImplementation.getInstance(globalService);
    }

    public static getInstance(globalService): RecentFilesController {
        if (this.singleInstance == null) {
            this.singleInstance = new RecentFilesController(globalService);
            return this.singleInstance;
        } else {
            return this.singleInstance;
        }
    }


    setEnvObjects(globalService) {
  
        this.globalService = globalService
        this.universalService = globalService.getUniversalServiceRef();
        this.router = globalService.getRouterRef();
        this.listService = globalService.getListServiceRef()
        this.loggerService = globalService.getLoggerServiceRef();
    }

    getRecentlyAccessedFiles(){
        // if((this.universalService.popUpToBeOpened == 'copyPopUp' || this.universalService.popUpToBeOpened == 'movePopUp') && (document.getElementById("recentFilesWrapperId")==null))
        // return
        //this.universalService.showLoader = true;
        const isSeeAllRecentFiles = window.location.pathname.includes("filter/recent");
        this.universalService.fetchAllRecentFiles = isSeeAllRecentFiles? true : false;
        const limit  = isSeeAllRecentFiles ? 200 : 10;
        var url= ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + "?limit=" + limit + "&sort=%2DlastAccessedDate";
        this.recentFilesImplementation.setHandler(this.globalService);
        this.recentFilesImplementation.getRecentlyAccessedFiles(url,true); 
    }

    getAllRecentFiles(){  
        this.universalService.nameSort = null;
        this.universalService.showLoader = true;
        this.universalService.shareViewTypeSetting();
        this.universalService.fetchAllRecentFiles = true;
        this.universalService.recentFilesListView = this.universalService.listView;
        var url= ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + "?limit=100&sort=%2DlastAccessedDate";
        this.recentFilesImplementation.setHandler(this.globalService);
        this.recentFilesImplementation.getRecentlyAccessedFiles(url,false);

    }


    decideScrollCall(){
        if(this.listService.listOptions.api.getVerticalPixelRange().top != 0){
        this.universalService.scrollToTopIcon = true;
        }else{
        this.universalService.scrollToTopIcon = false;
        }  
    }


    async updateUIAfterPerformingAction(list,executedTask){
        if(executedTask == 'TRASH' || executedTask == "MOVE"){
            if( executedTask == "MOVE"){
                this.universalService.showLoader = false;
                this.universalService.popUpToBeOpened = "";
                this.listService.deSelectAll(null);
                if((this.universalService.showPreview && executedTask == 'MOVE')){
                    var result = await this.fileOperationsImplementation.updateSummaryCountsAndUI(this.recentFilesImplementation.sortByLastAccessedDateArray,list,executedTask);
                    this.recentFilesImplementation.sortByLastAccessedDateArray = result
                }
                return;
            }else{
                this.fileOperationsImplementation.setHandler(this.globalService);
                    if((this.universalService.showPreview && executedTask == 'TRASH')||!this.universalService.showPreview){
                        var result = await this.fileOperationsImplementation.updateSummaryCountsAndUI(this.recentFilesImplementation.sortByLastAccessedDateArray,list,executedTask);
                        this.recentFilesImplementation.sortByLastAccessedDateArray = result
                        // if(this.recentFilesImplementation.sortByLastAccessedDateArray.length == 0 && this.universalService.fetchAllRecentFiles 
                        //     && this.universalService.currentTab == 'allfiles'){
                        //         this.universalService.emptyTab = true
                        // }

                    }

            }
            
        }else if(executedTask == 'RENAME' || executedTask == 'SETFAV' || executedTask == 'UNSETFAV' || executedTask == "SHAREPERMISSION"){
            this.fileOperationsImplementation.setHandler(this.globalService);
            var result = await this.fileOperationsImplementation.updateOnlyTheUI(this.recentFilesImplementation.sortByLastAccessedDateArray, list,executedTask)
            this.recentFilesImplementation.sortByLastAccessedDateArray = result
        }else{
            this.loggerService.log("task invalid",executedTask)
        }

        AppEvents.virtualDOMObservable.next({"updateVDOM":true})
    }

    selectAll(event){
        this.recentFilesImplementation.selectAll(event)
    }

   
    async fetchNextPageData(){
        this.getAllRecentFiles();
      }

      async updateOnlyUIOnRecentHorizontalPanel(executedTask) {
        var list = []
        if(executedTask == 'SETFAV' || executedTask == 'UNSETFAV'){
            this.fileOperationsImplementation.setHandler(this.globalService);
            if(this.universalService.selectedFile["horizontalItem"] || this.universalService.currentTab == "Home"){
                list = this.universalService.recentFilesPreviewArray;
            }else{
                list = this.universalService.objectsPreviewArray
            }
            var result = await this.fileOperationsImplementation.updateOnlyTheUIWithoutMonthWiseSegregation(list, this.universalService.selectedNodes, executedTask)
            list = result;
        }
      }

      //Get recent upload horizontal panel data - temporary api, we will get single 
      getRecentlyUploadedFiles(){
        var self = this;
        const isSeeAllRecentFiles = window.location.pathname.includes("filter/recent");
        this.universalService.fetchAllRecentFiles = isSeeAllRecentFiles? true : false;
        //var mimeTypes = ["image", "video", "audio", "applicationAndText"];       
        var mimeTypes = [
            {
                "filterCode":"image",
                "filterName":"photos"
            },
            {
                "filterCode":"video",
                "filterName":"videos"
            },
            {
                "filterCode":"audio",
                "filterName":"audio"
            },
            {
                "filterCode":"applicationAndText",
                "filterName":"docs"
            },
        ] 
        this.recentFilesImplementation.setHandler(this.globalService);
        mimeTypes.forEach(mime => {
            var limit = self.recentFilesImplementation.getLimitOfObjectsForRecentUploadSection(mime.filterCode);
            var url= ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + "?filterCode="+mime.filterCode+"&limit=" + limit + "&sort=%2DcreatedDate";
            self.recentFilesImplementation.recentUploadsAPI(url, mime.filterCode, mime.filterName);     
        });

    }

    //Get recent upload horizontal panel data 
    getHomePageRecentlyUploadedObjects(){
        var self = this;
        const isSeeAllRecentFiles = window.location.pathname.includes("filter/recent");
        this.universalService.fetchAllRecentFiles = isSeeAllRecentFiles? true : false;
        this.recentFilesImplementation.setHandler(this.globalService);
        
        var url= ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + ENV_CONFIG.commonUrls["nmsRecentObjectsHomePage"];
        self.recentFilesImplementation.homePageRecentUploadObjectsAPI(url);
        
    }
    
}